export type GatePhase = "waiting" | "starting" | "started";

export interface GateState {
  dismissed: boolean;
  companyName: string | null;
  phase: GatePhase;
  error: string | null;
}

/**
 * Whether the gate should release the round on its own.
 *
 * A saved name means the player has nothing to type, so the round starts as
 * soon as the briefing closes. That automatic start happens once: after the
 * server refuses it (a full house, or this connection's own cap, which waiting
 * does not cure) the refusal stays on screen and only the button retries.
 * Without the `error` guard a refusal flips the phase back to "waiting" and the
 * effect fires /start again at network speed.
 */
export function shouldAutoStart(state: GateState): boolean {
  return (
    state.dismissed &&
    state.companyName !== null &&
    state.companyName !== "" &&
    state.phase === "waiting" &&
    state.error === null
  );
}
